import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-autorita-indipendenti-regolatorie-view',
  templateUrl: './form-autorita-indipendenti-regolatorie-view.component.html',
  styleUrls: ['./form-autorita-indipendenti-regolatorie-view.component.css']
})
export class FormAutoritaIndipendentiRegolatorieViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
